import React from 'react';
import { isMobile } from 'react-device-detect';
import { mergeClasses, Button } from '@fluentui/react-components';

import WidgetContainer from 'src/components/molecules/widget-container/WidgetContainer';
import { useStore } from 'src/hooks/useStore';
import { DAILY_HABIT_TEXT_KEYS, GOALS_PLANS_URL } from 'src/utils/constants';
import { getInterstitialImageUrl, getWebMdPage, openExternalUrl } from 'src/utils/utils';
import EnhancedButton from 'src/components/atoms/enhanced-button/EnhancedButton';
import DailyHabitsInterstitialMessage from '../daily-habits-interstitial-message/DailyHabitsInterstitialMessage';
import { useDailyHabitInterstitialStyles } from './DailyHabitsInterstitial.styles';

interface DailyHabitsInterstitialProps {
  completedPlanNames: string[]
  failedPlanNames: string[]
  onChange: () => void
}

const DailyHabitsInterstitial: React.FC<DailyHabitsInterstitialProps> = ({
  completedPlanNames,
  failedPlanNames,
  onChange,
}) => {
  const classes = useDailyHabitInterstitialStyles();
  const { homeWidgetTextStore } = useStore();

  const containerClass = mergeClasses(
    classes.container,
    isMobile && classes.containerMobile,
  );
  const buttonContainerClass = mergeClasses(
    classes.buttonContainer,
    isMobile && classes.buttonContainerMobile,
  );

  const interstitialImageUrl = getInterstitialImageUrl(completedPlanNames.length, failedPlanNames.length);
  const goalsPlansUrl = getWebMdPage(GOALS_PLANS_URL);
  return (
    <WidgetContainer title="Daily Habits">
      <div
        className={mergeClasses(classes.container, containerClass)}
        data-testid="daily-habits-interstitial-container"
      >
        <div className={classes.imageContainer}>
          <img
            data-testid="daily-habits-interstitial-image"
            src={interstitialImageUrl}
            alt="Daily habits plan status illustration"
            className={classes.image}
          />
        </div>
        <div className={classes.messageContainer}>
          <DailyHabitsInterstitialMessage
            completedPlanNames={completedPlanNames}
            failedPlanNames={failedPlanNames}
          />
          <div className={buttonContainerClass}>
            <Button onClick={onChange} className={classes.notNowButton} appearance="transparent" data-testid="not-now-button">
              {homeWidgetTextStore.getHomeWidgetText(DAILY_HABIT_TEXT_KEYS.NOT_NOW)}
            </Button>

            <EnhancedButton
              onClick={() => openExternalUrl(goalsPlansUrl)}
              data-testid="manage-plans-button"
              isExternal
              appearance="secondary"
            >
              {homeWidgetTextStore.getHomeWidgetText(DAILY_HABIT_TEXT_KEYS.MANAGE_PLANS)}
            </EnhancedButton>
          </div>
        </div>
      </div>
    </WidgetContainer>
  );
};

export default DailyHabitsInterstitial;
